import script from "./TileCol.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileCol.vue?vue&type=script&setup=true&lang=ts"

import "./TileCol.vue?vue&type=style&index=0&id=3784d03a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3784d03a"]])

export default __exports__